import { createContentTypeInputSchema } from "./content-type";

export const BOOKS_TYPE_SLUG = "books";

/** Initial editorial schema. The setup helper never replaces an existing type. */
export const booksContentTypeInput = createContentTypeInputSchema.parse({
  name: "Books",
  slug: BOOKS_TYPE_SLUG,
  titleFieldKey: "title",
  fields: [
    { key: "title", label: "Title", kind: "text", required: true, config: { minLength: 1, maxLength: 180 } },
    { key: "synopsis", label: "Short synopsis", kind: "text", required: true, config: { minLength: 1, maxLength: 360 } },
    { key: "cover", label: "Book cover", kind: "media", required: false, config: { multiple: false } },
    { key: "body", label: "About the book", kind: "richtext", required: false, config: {} },
  ],
});

/** Public homepage projection; never includes draft data or administrative fields. */
export interface HomepageBook {
  title: string;
  synopsis: string;
  coverUrl: string | null;
  href: string;
}

export interface HomepageBookFeed {
  items: HomepageBook[];
}
